// Constants — ported from eb-ui creator-collections-listing `src/_shared/constants.ts`.
//
// `@eventbrite/legacy-infra.i18n` gettext → the local `@/lib/gettext` shim (returns a
// plain string, so `.toString()` sites are unchanged).
//
// ★ BUGBOT (Medium): the previous version called `gettext` at MODULE-LOAD time,
// which — with the eager string shim (no lazy GenericLazyString) — froze every
// title in ENGLISH for the process lifetime: the module is evaluated before
// `_app` runs `setMessages`, so even a loaded catalog never picked up these
// strings. They are now GETTER FUNCTIONS that run inside the React render
// (after `setMessages` has set the active catalog for this request).
import { gettext } from '@/lib/gettext';

export const getMoreCollectionsFromThisOrganizerTitle = (): string =>
    gettext('More collections from this organizer');
export const getOtherEventsYouMayLikeTitle = (): string =>
    gettext('Other events you may like');

export const AUTOCREATED_COLLECTION_DEFAULT_IMAGE_URL =
    'https://cdn.evbstatic.com/s3-build/perm_001/9d9878/django/images/creator_collections/autocreated-collection-default.png';

// ★ BUGBOT (Medium): the API collection `name` is ALWAYS the un-translated
// English default Core stores server-side ("Your first collection"). The
// translated getter must NOT be used for DATA equality against that field
// (once a catalog exists, the comparison would stop matching in non-English
// locales and the autocreated tip/summary path would never activate). Keep the
// English SOURCE for identity checks; `getDefaultAutocreatedCollectionName()`
// remains available for DISPLAY use.
export const AUTOCREATED_COLLECTION_DEFAULT_NAME = 'Your first collection';

export const getDefaultAutocreatedCollectionName = (): string =>
    gettext('Your first collection');

export const getDefaultAutocreatedCollectionSummary = (): string =>
    gettext(
        "Edit this description to explain the theme of your collection. Don't be shy, have fun!",
    );

export const getDefaultAutocreatedCollectionPillTitle = (): string =>
    gettext("Let's publish your first collection");
